import React from 'react';

// Components
import StaticIconLabel from './StaticIconLabel';
import AnimationArrowIconLabel from './AnimationArrowIconLabel';

const ButtonLink = ({
  url,
  label,
  title,
  target = '',
  extraClasses = '',
  icon,
  staticMode = false,
  ariaLabel = "",
}) => {
  return (
    <a
      href={url}
      title={title}
      target={target}
      className={'btn group ' + extraClasses}
      {...(ariaLabel !== "" ? { "aria-label": ariaLabel } : {})}
    >
      {staticMode ? (
        <StaticIconLabel label={label} />
      ) : (
        <AnimationArrowIconLabel label={label} icon={icon} />
      )}
    </a>
  );
};

export default ButtonLink;
